import { BaseCanvasObject } from 'canvas/base-canvas-object';

export class CanvasRoundedRect extends BaseCanvasObject<RoundedRectDrawOptions> {
	private activeSide: 'front' | 'back' = 'front';

	constructor(options: RoundedRectDrawOptions) {
		super(options);
		this.setType('rounded-rect');
	}
}
